import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import loadable from '@loadable/component';

const DropIn = loadable(() => import('braintree-web-drop-in-react'));

class Component extends BaseComponent {
    constructor() {
        super();

        this.state = { bt_instance: null };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.bt_instance != this.state.bt_instance) {
            return true;
        }

        if (nextProps.error != this.props.error) {
            return true;
        }

        if (nextProps.submitting != this.props.submitting) {
            return true;
        }

        return false;
    }

    render({ braintree, submitting }, { bt_instance }) {
        return (
            <bt-subscription-form>
                <DropIn
                    options={{
                        authorization: braintree.client_token,
                        environment: braintree.environment,
                        vaultManager: false,
                        card: {
                            cardholderName: {
                                required: true,
                            },
                            overrides: {
                                fields: {
                                    number: {
                                        placeholder: '1234 5678 9012 3456',
                                    },
                                    cvv: {
                                        placeholder: '123',
                                    },
                                },
                            },
                        },
                    }}
                    onInstance={instance => this.setState({ bt_instance: instance })}
                />
                <div className='has-text-center has-margin-20-top'>
                    <button
                        disabled={!bt_instance || submitting}
                        className={`button button-warning ${!bt_instance || submitting ? 'disabled' : ''}`}
                        onClick={this.submit}
                    >
                        {submitting ? 'submitting…' : 'USE SELECTED CARD'}
                    </button>
                </div>
                {this.renderMessage()}
            </bt-subscription-form>
        );
    }

    submit = () => {
        this.props.checkoutUpdate({ error: null });

        this.state.bt_instance.requestPaymentMethod().then((payload) => {
            this.props.submit({
                nonce: payload.nonce,
                remote_key: this.props.remote_key,
            });
        }).catch((err) => {
            this.props.checkoutUpdate({
                error: err && err.message
                    ? err.message
                    : 'An error has occurred. Please contact <a href="service">customer support.</a>',
            });
        });
    }

    renderMessage = () => {
        if (this.props.error) {
            return (<p className='is-error has-text-center' dangerouslySetInnerHTML={{__html: this.props.error}} />);
        } else if (this.props.success) {
            return (<p className='is-success has-text-center'>Your Payment Method has been saved.</p>);
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    braintree: state.braintree,
    error: state.checkout && state.checkout.error,
    remote_key: state.subscription && state.subscription.remote_id,
    submitting: state.checkout && state.checkout.submitting,
    success: state.checkout && state.checkout.success,
});

const mapDispatchToProps = (dispatch) => ({
    checkoutUpdate: (payload) => dispatch({ type: 'checkout:update', payload: payload }),
    submit: (payload) => dispatch({ type: 'subscription:update-payment', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
